import { isLoggedIn, redirectAfterRegistration } from "./session";

if (isLoggedIn()) {
  redirectAfterRegistration();
}
